import { Space, Radio, DatePicker } from "antd";
import { useEffect, useState } from "react";
import { dayjsDate, getMonthStartEnd, getRangeStartEnd } from "../utils/functions";

function DateSelector({ value, onChange, mod = 'single' }) {
    const [mode, setMode] = useState(mod);
    const [singleMonth, setSingleMonth] = useState(value ? dayjsDate(value) : null);
    const [rangeMonths, setRangeMonths] = useState([
        value ? dayjsDate(value) : null, 
        dayjsDate(new Date())
    ]);

    // 当外部 value 或 mod 变化时，同步更新内部状态
    useEffect(() => {
        setMode(mod);
        if (mod === 'single') {
            setSingleMonth(value ? dayjsDate(value) : null);
        } else {
            // 如果是范围模式，value 应该是数组或单个值
            if (Array.isArray(value)) {
                setRangeMonths([
                    value[0] ? dayjsDate(value[0]) : null,
                    value[1] ? dayjsDate(value[1]) : dayjsDate(new Date())
                ]);
            } else {
                setRangeMonths([
                    value ? dayjsDate(value) : null,
                    dayjsDate(new Date())
                ]);
            }
        }
    }, [value, mod]);

    // 发送日期范围变化
    useEffect(() => {
        let result = { startTs: null, endTs: null };
        
        if (mode === 'single' && singleMonth) {
            result = getMonthStartEnd(singleMonth);
        } else if (mode === 'range' && rangeMonths[0]) {
            result = getRangeStartEnd(rangeMonths);
        }
        
        onChange && onChange(result);
    }, [singleMonth, rangeMonths, mode]);

    const handleRangeStartChange = (value) => {
        setRangeMonths(prev => [value, prev[1]]);
    };

    const handleRangeEndChange = (value) => {
        setRangeMonths(prev => [prev[0], value]);
    };

    return (
        <Space size={'middle'}>
            <Radio.Group value={mode} onChange={(e) => setMode(e.target.value)}>
                <Radio value="single">按单月</Radio>
                <Radio value="range">按范围</Radio>
            </Radio.Group>

            {mode === 'single' && (
                <DatePicker
                    picker="month"
                    placeholder="请选择月份"
                    value={singleMonth}
                    onChange={setSingleMonth}
                    allowClear
                />
            )}
            
            {mode === 'range' && (
                <>
                    <span>从</span>
                    <DatePicker
                        placeholder="开始日期"
                        value={rangeMonths[0]}
                        onChange={handleRangeStartChange}
                        allowClear
                    />
                    <span>到</span>
                    <DatePicker
                        placeholder="结束日期"
                        value={rangeMonths[1]}
                        onChange={handleRangeEndChange}
                        allowClear
                    />
                </>
            )}
        </Space>
    );
}

export default DateSelector;